import { createFileRoute, useParams } from '@tanstack/react-router';

import { useAuth } from '@/store/auth.ts';
import { CourseAssessmentsView } from '@/views/assessments/course-assessments-view.tsx';

// 课程 Survey 列表（ADR-024）。作答复用 quiz 尝试路由。
export const Route = createFileRoute('/_learner/courses_/$id/surveys')({
  component: SurveysTab,
});

function SurveysTab() {
  const { id } = useParams({ from: '/_learner/courses_/$id/surveys' });
  const user = useAuth((s) => s.user);
  if (!user) return null;
  return <CourseAssessmentsView kind="SURVEY" courseId={id} user={user} />;
}
